import { put, call, takeLatest } from 'redux-saga/effects';

import API from 'services/api';
import authService from 'services/authService';

import { fetchProfile, receivePaperlessTerms, receiveUser } from './actions';
import { PROFILE_FETCH_REQUEST } from './types';

export default function* root() {
  yield takeLatest(PROFILE_FETCH_REQUEST, watchFetchProfile);
}

function* watchFetchProfile() {
  try {
    const user = yield call(authService.profile);
    yield put(receiveUser(user));
  } catch (error) {
    yield call(fetchProfile.error(error));
  }
}

export function* getPaperlessTerms() {
  const paperlessTerms = yield call(API.general.paperlessTerms);
  yield put(receivePaperlessTerms(paperlessTerms));
}
